<mat-toolbar [ngClass]="userClass()">
  <app-hidden-menu></app-hidden-menu>

  <button *ngIf="authService.noOfMasks()>1" mat-icon-button [matMenuTriggerFor]="maskMenu">
    <mat-icon>menu</mat-icon>
  </button>
  <mat-menu #maskMenu="matMenu">

    <button mat-menu-item (click)="navigate('/mask1')" *ngIf="authService.maskAvailable('/mask1')">
      <mat-icon>assignment</mat-icon>
      <span>Acceptance</span>
    </button>
    <button mat-menu-item (click)="navigate('/mask2')" *ngIf="authService.maskAvailable('/mask2')">
      <mat-icon>assignment</mat-icon>
      <span>Acceptance</span>
    </button>
    <button mat-menu-item (click)="navigate('/mask3')" *ngIf="authService.maskAvailable('/mask3')">
      <mat-icon>assignment</mat-icon>
      <span>Warehouse Handling</span>
    </button>
    <button mat-menu-item (click)="navigate('/mask4')" *ngIf="authService.maskAvailable('/mask4')">
      <mat-icon>assignment</mat-icon>
      <span>Apron</span>
    </button>
  </mat-menu>

  <!--
  <span class="title-bar-text">Digitales Testfeld Air Cargo</span>
  <a href="https://www.bmvi.de/SharedDocs/DE/Artikel/DG/KI-Projekte/dtac.html" target="_blank" rel="noopener">
    <img width="52" height="52" src="assets/DTAC-Logo-96.png">
  </a>
  -->
  <span fxFlex="1 1 auto"></span>
  <!-- <p>{{time| date:'yyyy-MM-dd HH:mm'}} </p> -->
  <span fxFlex="1 1 auto"></span>

  <button mat-raised-button (click)="scan()" *ngIf="userService.loggedIn()">
    Scan
    <mat-icon>qr_code_scanner</mat-icon>
  </button>
  <span fxFlex="1 1 auto"></span>
  <p>{{username}}</p>

  <button mat-icon-button [matMenuTriggerFor]="loginMenu">
    <mat-icon>person</mat-icon>
  </button>
  <mat-menu #loginMenu="matMenu">
    <button *ngIf="userService.loggedIn()" mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
    <button *ngIf="!userService.loggedIn()" mat-menu-item (click)="login()">
      <mat-icon>login</mat-icon>
      <span>Login</span>
    </button>
  </mat-menu>

</mat-toolbar>
<router-outlet></router-outlet>